import { render, staticRenderFns } from "./PharmacyMainMenu.vue?vue&type=template&id=60edb9e0&scoped=true"
import script from "./PharmacyMainMenu.vue?vue&type=script&lang=js"
export * from "./PharmacyMainMenu.vue?vue&type=script&lang=js"
import style0 from "./PharmacyMainMenu.vue?vue&type=style&index=0&id=60edb9e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60edb9e0",
  null
  
)

export default component.exports